import { useEffect } from "react";
import { SITE_NAME, SITE_URL } from "../config/site";

function upsertMeta(selector, attrs, content) {
  if (!content) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Il tuo studio tecnico, ovunque tu sia`;
    document.title = full;
    upsertMeta('meta[name="description"]', { name: "description" }, description);
    upsertMeta('meta[property="og:title"]', { property: "og:title" }, full);
    upsertMeta('meta[property="og:description"]', { property: "og:description" }, description);
    if (SITE_URL) {
      upsertMeta('meta[property="og:url"]', { property: "og:url" }, `${SITE_URL}${path || ""}`);
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.rel = "canonical";
        document.head.appendChild(canonical);
      }
      canonical.href = `${SITE_URL}${path || ""}`;
    }
  }, [title, description, path]);
  return null;
}
